export default {"src":"/_next/static/media/DT.e5935018.svg","height":18,"width":18};